export default __webpack_public_path__ + "f4dd4aec8f32890f9ddd0952a5c52ef7.png";